import i18nFactory from '@yandex-int/i18n';
import { Action } from 'redux';
import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import {
    AddCreatedInternalProduct,
    addCreatedInternalProductAction
} from '../../../../actions/products/internal/addCreatedInternalProduct';
import {
    CREATE_INTERNAL_PRODUCT,
    CreateInternalProduct
} from '../../../../actions/products/internal/createInternalProduct';
import {
    UpdateInternalProductsForm,
    updateInternalProductsFormAction
} from '../../../../actions/products/internal/updateInternalProductsForm';
import {
    UpdateInternalProductsPageStatus,
    updateInternalProductsPageStatusAction
} from '../../../../actions/products/internal/updateInternalProductsPageStatus';
import { selectProductsSortParams } from '../../../../selectors/products';
import { mapTextToErrors } from '../../../../service/ErrorsMapper/ErrorsMapper';
import { showNoticeMessage } from '../../../../service/GridHelpers/GridHelpers';
import { internalProductsErrorsMapper } from '../../../../service/InternalToolsErrorsMappers/InternalToolsErrorsMappers';
import { EpicDeps } from '../../../../service/StoreFactory';
import { NoticeType } from '../../../../typings/grid';
import { ProductsPageStates } from '../../../../typings/products';
import { State } from '../../../../typings/state';

import * as keyset from './createInternalProductEpic.i18n';
const i18n = i18nFactory(keyset);

type EpicActions = AddCreatedInternalProduct | UpdateInternalProductsPageStatus | UpdateInternalProductsForm;

export const createInternalProductEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) =>
    action$.pipe(
        ofType(CREATE_INTERNAL_PRODUCT),
        mergeMap(
            (action: CreateInternalProduct): Observable<EpicActions> => {
                const { productName, description } = action;

                return from(deps.productsDataProvider.createProduct(productName, description)).pipe(
                    mergeMap(response => {
                        const sortParams = selectProductsSortParams(store$.value);

                        showNoticeMessage(NoticeType.success, i18n('success-add'));

                        return of(
                            addCreatedInternalProductAction(response, sortParams),
                            updateInternalProductsPageStatusAction(ProductsPageStates.LOADED),
                            updateInternalProductsFormAction({
                                product: {
                                    productName: '',
                                    description: ''
                                },
                                isValid: true,
                                isEnabled: false
                            })
                        );
                    }),
                    catchError(e => {
                        const errorsClientWithText = mapTextToErrors(e.errors, internalProductsErrorsMapper);
                        showNoticeMessage(
                            NoticeType.error,
                            errorsClientWithText.length ? errorsClientWithText[0].text : i18n('error-add')
                        );

                        return of(updateInternalProductsPageStatusAction(ProductsPageStates.PENDING));
                    })
                );
            }
        )
    );
